export class EnvironmentConfig {
  endPoint: string;
}
